import React, { Component } from 'react';

class Footer extends Component {
	render() {
		return (
			<footer>
				<div className="container">
					<p>Somos a Associação Brasileira das Entidades dos Mercados Financeiro e de Capitais. Falamos em nome de instituições como bancos, gestoras, corretoras, distribuidoras e administradoras. Nascemos em 2009 a partir da união de duas entidades, mas representamos os mercados há quatro décadas. Nosso modelo de atuação é organizado em torno de quatro compromissos: representar, autorregular, informar e educar.</p>
				</div>
			</footer>
			);
	}
	
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js